import pipeline from '../../services/pipeline';
import utils from '@/services/utils';
import axiosApi from '../../services/inteceptor';

const API_ADMIN = `${utils.svcUrl()}pipeline`;

const mutations = {
  ADD_SEGMENT(state, payload) {
    state.pipelineSegmentsDetails.segmentList.push(payload);
  },
  REMOVE_SEGMENT(state, index) {
    state.pipelineSegmentsDetails.segmentList.splice(index, 1);
  },
  CHANGE_CREATING_LOADER(state, status) {
    state.creatingLoader = status;
  },
  CHANGE_FETCHING_PIPELINE_LOADER(state, status) {
    state.fetchingLoader = status;
  },
  SET_PIPELINE_DATA(state, payload) {
    state.pipelinesList = payload;
  },
  NEW_PIPELINE_POPUP(state, status) {
    state.newPipelinePopup = status;
  },
  SEGMENT_LIST_POPUP(state, status) {
    state.segmentListPopup = status;
  },
  NEW_SEGMENT_POPUP(state, status) {
    state.newSegmentPopup = status;
  },
  ADD_SEGMENT_LOADER(state, status) {
    state.addSegmentLoader = status;
  },
  SET_CURRENT_PIPELINE(state, payload) {
    state.currentPipeline = payload ? JSON.parse(payload)?._id : '';
    state.currentPipelineDetails = payload || '';
  },
  GET_DETAILS_LOADER(state, pipelineId) {
    state.getPipelineDetailsLoader = pipelineId;
  },
  DELETE_SEGMENT_LOADER(state, status) {
    state.deleteSegmentLoader = status;
  },
  SET_PIPELINE_DETAILS(state, payload) {
    state.pipelineSegmentsDetails = payload;
  },
  SET_PIPELINE_STUDENT_COUNT(state, payload) {
    state.pipelineStudentsCount = payload - 1;
  },
};
const initialState = {
  pipelinesDetails: {},
  pipelinesList: [],
  creatingLoader: false,
  fetchingLoader: false,
  newPipelinePopup: false,
  segmentListPopup: false,
  newSegmentPopup: false,
  addSegmentLoader: false,
  deleteSegmentLoader: false,
  getPipelineDetailsLoader: false,
  pipelineStudentsCount: 0,
  currentPipeline: '',
  currentPipelineDetails: '',
  pipelineSegmentsDetails: [],
};
const actions = {
  createPipeline: async ({ commit }, payload) => {
    try {
      commit('CHANGE_CREATING_LOADER', true);
      const response = await pipeline.createPipeline(payload);
      commit('CHANGE_CREATING_LOADER', false);
      console.log(response);
    } catch (error) {
      commit('CHANGE_CREATING_LOADER', false);
      throw Error(error?.response?.data?.message);
    }
  },
  fetchPipelineData: async ({ commit }) => {
    try {
      commit('toggleLoading', true);
      const response = await pipeline.getAlPipelines();
      commit('SET_PIPELINE_DATA', response?.data);
      commit('toggleLoading', false);
    } catch (error) {
      console.log(error);
      commit('toggleLoading', false);
      commit('SET_PIPELINE_DATA', []);
    }
  },
  addSegmentToPipeline: async ({ commit, state }, { segmentId }) => {
    try {
      commit('ADD_SEGMENT_LOADER', true);
      const order = state.pipelineSegmentsDetails?.length + 1;
      const pipelineId = state?.currentPipeline;
      console.log(order, pipelineId, segmentId);
      const response = await pipeline.addNewSegmentToPipeline({ order, pipelineId, segmentId });
      commit('ADD_SEGMENT_LOADER', false);
      console.log(response);
      return response;
    } catch (error) {
      commit('ADD_SEGMENT_LOADER', false);
      console.log('adding pipeline err', error);
      throw Error(error?.response?.data?.message);
    }
  },
  getPipelineDetails: async ({ commit, state }) => {
    try {
      commit('GET_DETAILS_LOADER', true);
      const response = await pipeline.getPipelineDetails(state?.currentPipeline);
      commit('GET_DETAILS_LOADER', false);
      commit('SET_PIPELINE_DETAILS', response?.data);
      commit('SET_PIPELINE_STUDENT_COUNT', response?.data.reduce((acc, obj) => acc + obj?.userInfos.length, 0));
      return response;
    } catch (error) {
      commit('GET_DETAILS_LOADER', false);
      console.log('get pipeline details err', error);
    }
    return null;
  },
  deleteSegmentFromPipeline: async ({ commit, state }, segmentId) => {
    try {
      commit('DELETE_SEGMENT_LOADER', true);
      const pipelineId = state?.currentPipeline;
      const response = await pipeline.deleteSegmentToPipeline({ pipelineId, segmentId });
      commit('DELETE_SEGMENT_LOADER', false);
      console.log(response);
      return response;
    } catch (error) {
      commit('DELETE_SEGMENT_LOADER', false);
      console.log('delete pipeline err', error);
    }
    return null;
  },
  changeSegmentOrder: async ({ state }, { pipelineSegmentsDetails }) => {
    try {
      const pipelineId = state?.currentPipeline;
      const response = await pipeline.changeSegmentOrder({ pipelineId, pipelineSegmentsDetails });
      return response;
    } catch (error) {
      console.log('change segment order err', error);
    }
    return null;
  },
  deletePipeline: async ({ state }, payload) => {
    try {
      const { pipelineId = state?.currentPipeline } = payload;
      const response = await axiosApi.delete(`${API_ADMIN}/delete/${pipelineId}`);
      return response;
    } catch (error) {
      console.log('delete pipeline err', error);
      throw Error(error?.response?.data?.message);
    }
  },
  editPipeline: async ({ state }, payload) => {
    try {
      const { pipelineId = state?.currentPipeline, pipelineName } = payload;
      const response = await axiosApi.put(`${API_ADMIN}/edit`, { pipelineId, pipeline_name: pipelineName });
      return response;
    } catch (error) {
      console.log('edit pipeline err', error);
      throw Error(error?.response?.data?.message);
    }
  },
};

export default {
  state: initialState,
  mutations,
  actions,
};
